import { render, staticRenderFns } from "./copy-right.vue?vue&type=template&id=53125866&scoped=true"
import script from "./copy-right.vue?vue&type=script&lang=js"
export * from "./copy-right.vue?vue&type=script&lang=js"
import style0 from "./copy-right.vue?vue&type=style&index=0&id=53125866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53125866",
  null
  
)

export default component.exports